import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PoolingService {

  baseURL = environment.baseUrl + 'pol';

  constructor(private http: HttpClient) {
  }
  updateUrl(eventId: any,url:any): Observable<any> {
    const params = new HttpParams()
      .set('userId',1)
      .set('url',url)
    return this.http.put<any>(`${this.baseURL}/event/`+eventId,{},{params});
  }
}
